import RequestExpiredDateMain from "../../../../features/customer/request-expired-date/components/request-expired-date-main";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../../store/ui-slice";

const title = "Request Expired Date";

const RequestExpiredDatePage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <RequestExpiredDateMain />;
};

export default RequestExpiredDatePage;
